import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ticket } from 'src/app/shared/models';
import { StorageService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { isPrevisionHiddenForProvider } from 'src/app/shared/utils/prevision-visibility';

@Component({
  selector: 'app-ticket-list-tile',
  templateUrl: './ticket-list-tile.component.html',
  styleUrls: ['./ticket-list-tile.component.scss']
})
export class TicketListTileComponent implements OnInit {
  @Input() ticket: Ticket;

  currentTicket: Ticket;

  constructor(
    private storageService: StorageService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  // Empresa configurada para nao exibir a previsao de atendimento.
  get hidePrevision(): boolean {
    return isPrevisionHiddenForProvider(this.ticket && this.ticket.providerId);
  }

  goToTrack () {
    if (this.ticket.providerId === environment.boticarioProviderId) {
      this.storageService.setCurrentTicket(this.ticket);
      this.router.navigate(['/boticario/track']);
    } else if (this.ticket.terminalAccessKey) {
      this.router.navigate(['/queue', this.ticket.terminalAccessKey, 'ticket', this.ticket.accessKey]);
    } else {
      this.storageService.setCurrentTicket(this.ticket);
      this.router.navigate(['/track']);
    }
  }

}
